import api from "@/api";

export default {
  // 1. Lấy dữ liệu tổng hợp (Kế hoạch + Nhân sự + Lịch sử)
  // GET /api/cong-trinh/{id}/ke-hoach-nhan-su?date=2024-01-20
  getData(congTrinhId, dateStr) {
    return api.get(`/api/cong-trinh/${congTrinhId}/ke-hoach-nhan-su`, {
      params: { date: dateStr }
    });
  },

  // 2. Tạo Kế hoạch (Đầu việc)
  createPlan(congTrinhId, data) {
    return api.post(`/api/cong-trinh/${congTrinhId}/ke-hoach`, data);
  },

  // 3. Sửa Kế hoạch
  updatePlan(planId, data) {
    return api.put(`/api/cong-trinh/ke-hoach/${planId}`, data);
  },

  // 4. Xóa Kế hoạch
  deletePlan(planId) {
    return api.delete(`/api/cong-trinh/ke-hoach/${planId}`);
  },

  // 5. Lưu Phân công nhân sự (Bulk Save)
  savePhanCong(congTrinhId, data) {
    return api.post(`/api/cong-trinh/${congTrinhId}/phan-cong`, data);
  },

  calendarEvents(congTrinhId,month,year){
    return api.get(`/api/cong-trinh/${congTrinhId}/calendar-events`, { params: { month, year } })
  },
  fetchChecklist(congTrinhId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/checklist`);
  },
  toggleChecklist(planId, isDone) {
    return api.patch(`/api/cong-trinh/checklist/${planId}/toggle`, null, {
                params: { done: isDone }
            });
  }
};